import { TimelineLite, CSSPlugin, Power2, TweenMax } from "gsap/all";
import perfectScrollbar from "perfect-scrollbar";

import $$ from "../toolkit/$$";

// prevent tree shaking:
const gsapPlugins = [CSSPlugin];

class Nav {
  // Navigation open state.
  public isOpen: boolean = false;

  // Navigation toggling state.
  public isToggling: boolean = false;

  // Navigation opening state.
  public isOpening: boolean = false;

  // Navigation closing state.
  public isClosing: boolean = false;

  // Navigation animation OPEN timeline.
  public openTL: any = new TimelineLite({
    paused: true,

    onComplete: () => this.onNavOpened(),
    onReverseComplete: () => this.onNavClosed(),
    ease: Power2.easeOut
  });

  // Navigation animation LABEL timeline.
  public labelTL: any = new TimelineLite({
    paused: true,
    ease: Power2.easeOut
  });

  // Perfect Scrollbar instance
  public pScrollbar: any = null;

  // Navigation $element.
  public $nav: HTMLElement = $$("[data-nav]")[0];

  // Trigger $element.
  public $trigger: HTMLElement = $$("[data-nav-trigger]")[0];

  // Trigger open label $element.
  public $openLabel: HTMLElement = $$("[data-trigger-open]")[0];

  // Trigger close label $element.
  public $closeLabel: HTMLElement = $$("[data-trigger-close]")[0];

  // Nav items $element Nodelist.
  public $$items: NodeListOf<HTMLElement> = $$("[data-nav-item]");

  // Submenu triggers $element Nodelist.
  public $$submenuTriggers: NodeListOf<HTMLElement> = $$(
    "[data-submenu-trigger]"
  );

  // Perfect scrollbar instantion $element.
  public $scroll: HTMLElement = $$("[data-nav-scroll]")[0];

  constructor() {
    this.clickAwayHandler = this.clickAwayHandler.bind(this);
    this.escapeHandler = this.escapeHandler.bind(this);

    this.init();
  }

  init() {
    const navWidth = this.$nav.getBoundingClientRect().width;
    const labelHeight = this.$openLabel.getBoundingClientRect().height;

    this.labelTL
      .add(TweenMax.to(this.$openLabel, 0.3, { y: labelHeight }))
      .add(TweenMax.to(this.$closeLabel, 0.3, { y: -labelHeight }));

    this.openTL.add(TweenMax.to(this.$nav, 1, { x: -navWidth }));

    [].forEach.call(this.$$items, ($item: HTMLElement) => {
      this.openTL.add(
        TweenMax.from($item, 1.2, { opacity: 0, y: 48 }),
        "-=1.1"
      );
    });

    if (window.innerWidth > 768) {
      this.pScrollbar = new perfectScrollbar(this.$scroll, {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20
      });
    }

    [].forEach.call(this.$$submenuTriggers, ($trigger: HTMLElement) => {
      $trigger.addEventListener("click", () => this.openSubmenu($trigger));
    });

    this.$trigger.addEventListener("click", () => {
      if (!this.isClosing && (this.isOpening || this.isOpen)) this.closeNav();
      else if (!this.isOpening && (this.isClosing || !this.isOpen))
        this.openNav();
    });
  }

  openNav() {
    this.openTL.timeScale(2).play();
    this.labelTL.play();
    this.isOpening = true;
    this.isClosing = false;
    setTimeout(() => {
      document.addEventListener("click", this.clickAwayHandler, {
        passive: true
      });
      document.addEventListener("keyup", this.escapeHandler, { passive: true });
    }, 0);
  }

  closeNav() {
    this.openTL.timeScale(3).reverse();
    this.labelTL.reverse();
    this.isOpening = false;
    this.isClosing = true;
    document.removeEventListener("click", this.clickAwayHandler);
    document.removeEventListener("keyup", this.escapeHandler);
  }

  onNavOpened() {
    this.isOpen = true;
    this.isOpening = false;
    this.isClosing = false;

    this.$trigger.classList.add("open-state");
  }

  onNavClosed() {
    this.isOpen = false;
    this.isOpening = false;
    this.isClosing = false;

    this.$trigger.classList.remove("open-state");
  }

  openSubmenu($trigger) {
    const isOpen = $trigger.matches(".is-open");
    [].forEach.call(this.$$submenuTriggers, $t =>
      $t.classList.remove("is-open")
    );
    if (!isOpen) $trigger.classList.add("is-open");
  }

  clickAwayHandler(e: MouseEvent) {
    if (!(e.target as HTMLElement).closest("[data-nav]")) this.closeNav();
  }

  escapeHandler(e: KeyboardEvent) {
    if (e.key === "Escape") this.closeNav();
  }
}

export default Nav;
